// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__ymmR1","footer":"ModalCreateQualiphyProcedure_footer__j4dY7","additionData":"ModalCreateQualiphyProcedure_additionData__1NyP6"};